<template lang="html">

    <div class="wrapper margin-menu -togo">

        <section class="intro column-center -togo">
            <h2>Proyecto educativo en Togo</h2>
        </section>

        <section class="breadcrumb">
            <nav class="container row-end">
                <router-link to="/">Inicio</router-link>
                <router-link :to="$t('enlaces.aguaparatodos')">Agua para todos</router-link>
                <router-link :to="$t('enlaces.proyectosencurso')">Proyectos en curso</router-link>
                <router-link :to="$t('enlaces.proyecto')+'/togo'">Proyecto educativo en Togo</router-link>
            </nav>
        </section>

        <main>


            <section class="container">

                <h2 class="title-intro row-center">
                    <span>Proyecto</span>
                    <span>Educativo</span>
                </h2>

                <p class="texto-intro">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut pretium pretium tempor. Ut eget
                    imperdiet neque. In volutpat ante semper. Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Ut pretium pretium tempor. Ut eget imperdiet neque.
                </p>

            </section>


            <section class="objetivo-togo">

                <h2 class="big-title left container">Objetivo</h2>

                <div class="red-border-box">
                    <h3 class="title-intro">
                        Nuestro <strong>objetivo</strong>
                    </h3>
                    <p><strong>Construir un edificio que albergue la secundaria de la futura escuela Matilde
                            Pascual,</strong> como continuación del parvulario M. Matilde Pascual, que dote a las zonas
                        rurales de togo del primer centro edicativo con las tres etapas formales de la educación en un
                        mismo centro.​</p>

                    <img src="/static/img/togo/ninos-togo.jpg" alt="Niños togo">
                </div>
            </section>



            <section class="objetivos -togo container row-between ais">
                <article class="column-center donde">
                    <p>El proyecto se realizará en Afagman Glbeta en el departamento marítino, Togo.</p>
                    <h2 class="big-title">Dónde</h2>
                    <img src="/static/img/togo/sombrero.svg" class="sombrero">
                </article>
                <article class="column-center">
                    <p>COSTE</p>
                    <p><strong>57.000€</strong></p>
                </article>
                <article class="column-center">
                    <p><strong>TIEMPO DE REALIZACIÓN</strong></p>
                    <p>10 meses</p>
                    <p>8 de construcción y 2 de evaluación</p>
                </article>
                <article class="column-center">
                    <p><strong>PLAZO MÁXIMO DE FINALIZACIÓN</strong></p>
                    <p>Junio 2020</p></li>
                </article>

                
                <div class="contenedor-mapa-togo row-center">
                    <img src="/static/img/togo/mapa-mundo.svg" class="mapa-mundo">
                    <img src="/static/img/togo/mapa-togo.svg" class="mapa-togo">
                    <span class="line"></span>
                </div>
                
                <h2 class="big-title">Togo</h2>

                <ul>
                    <li>• 	<strong>Togo, en el golfo de Guinea, antigua colonia alemana y francesa</strong>, es una república presidencialista con una gran diversidad cultural.</li>
                    <li>• 	<strong>Cuenta con una geografía variable y climas diversos</strong>: sabana, llanuras, pantanos, etc.. y una flora y fauna abundante.</li>
                    <li>• 	<strong>Ocupa el puesto 166º IDH</strong> con una tasa pobreza del 58,3% <strong>y una esperanza de vida de 60,3 años.</strong></li>
                    <li>• 	<strong>La renta per cápita es de 540 euros, no alcanza 6 de 8 ODM</strong> y tiene una alta dependencia de agricultura.</li>
                </ul>

            </section>

            <section class="banner-matilde row-center">

                <div class="contenedor-texto">
                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sint itaque quam cumque iusto alias
                        cupiditate. In fugiat autem iste aliquid mollitia modi deserunt incidunt accusantium, odio,
                        voluptates maiores illum qui?</p>
                    <h2>Matilde Pascual</h2>
                </div>
                <img src="/static/img/togo/matilde.png" alt="Matilde Pascual">

            </section>


            <section class="tips-educacion container row-center">

                <article>
                    <div class="imagen"><img src="/static/img/togo/tip-0.svg" alt="imagen"></div>
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsa porro deserunt facere cupiditate
                        similique dicta odit atque, laborum ullam cum laudantium. Iusto sequi distinctio dolores
                        molestiae nam. Fuga, vel. Maxime.</p>
                </article>
                <article>
                    <div class="imagen"><img src="/static/img/togo/tip-1.svg" alt="imagen"></div>
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsa porro deserunt facere cupiditate
                        similique dicta odit atque, laborum ullam cum laudantium. Iusto sequi distinctio dolores
                        molestiae nam. Fuga, vel. Maxime.</p>
                </article>
                <article>
                    <div class="imagen"><img src="/static/img/togo/tip-2.svg" alt="imagen"></div>
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsa porro deserunt facere cupiditate
                        similique dicta odit atque, laborum ullam cum laudantium. Iusto sequi distinctio dolores
                        molestiae nam. Fuga, vel. Maxime.</p>
                </article>
                <article>
                    <div class="imagen"><img src="/static/img/togo/tip-3.svg" alt="imagen"></div>
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsa porro deserunt facere cupiditate
                        similique dicta odit atque, laborum ullam cum laudantium. Iusto sequi distinctio dolores
                        molestiae nam. Fuga, vel. Maxime.</p>
                </article>



            </section>

            <section class="time-line">
                <div class="container row-center ais">

                    <div class="tip">
                        <h2>1970</h2>
                        <p>Llegada MIC a TOgo</p>
                    </div>

                    <div class="tip">
                        <h2>1983</h2>
                        <p>Comunidad GBLETA</p>
                        <p>(Con Matilde)</p>
                    </div>

                    <div class="tip">
                        <h2>1992</h2>
                        <p>MIC Escuela</p>
                        <p>Menagere</p>
                    </div>

                    <div class="tip">
                        <h2>1992</h2>
                        <p>MIC Escuela</p>
                        <p>Menagere</p>
                    </div>

                    <div class="tip">
                        <h2>2009</h2>
                        <p>Creación parvulario</p>
                    </div>

                    <div class="tip">
                        <h2>2014</h2>
                        <p>MIC Escuela</p>
                        <p>San Andrés</p>
                    </div>

                    <div class="tip">
                        <h2>2015</h2>
                        <p>Campaña todos con Togo</p>
                        <p>e inicio Proyecto Educativo</p>
                    </div>



                </div>
            </section>

            <section class="checks-togo container -small row-start ais">

                <h3>Escuela Rural San Andrés </h3>
                <h3>Parvulario M. Matilde</h3>
                <h3>Comunidad MIC</h3>
                <h3>Comedor</h3>
                <h3>Escuela promoción femenina</h3>
                <h3>Nueva Escuela</h3>

                <img src="/static/img/togo/checks.svg" class="check">

            </section>


            <div class="contenedor-boton row-center">
                <a href="" class="btn with-border">Descarga más información</a>
            </div>



            <section class="colabora-project">
                <div class="container colabora-title">
                    <h2 class="big-title">Colabora</h2>
                    <h3 class="title-intro no-line">¿Te animas a <strong>colaborar</strong>?</h3>
                    <img src="/static/img/corazon.svg" alt="Corazón">
                    <h3 class="title-intro small">
                        Con tu donativo podremos seguir acercando el agua a <strong>aquellos que más lo
                            necesitan</strong>
                    </h3>
                </div>

                <div class="payment-container">
                    <payment :id="'1'"></payment>
                </div>


            </section>


        </main>

    </div>

</template>

<script lang="js">

    import payment from '@/components/parts/payment'

    export default {
        name: 'project-angola',
        components: {
            'payment': payment
        },
        methods: {
            toPayment() {
                $("html,body").animate({ scrollTop: $(".colabora-project").position().top - 150 }, '500');
            }
        }
    }
</script>

<style scoped lang="scss">
    .texto-intro {
        max-width: 600px;
    }

    .title-intro img {
        max-width: 230px;
        max-height: 110px;
        margin: 0 20px;
    }

    .colabora-project {
        margin-top: 50px;
    }
</style>


// WEBPACK FOOTER //
// src/components/views/project-togo.vue